import React from "react"
export default function Logo(props) {
  return <h1>OOP Notes</h1>
}
